import { render, staticRenderFns } from "./PrimarySuccess.vue?vue&type=template&id=f2316354&scoped=true&"
import script from "./PrimarySuccess.vue?vue&type=script&lang=js&"
export * from "./PrimarySuccess.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySuccess.vue?vue&type=style&index=0&id=f2316354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2316354",
  null
  
)

export default component.exports